import { useState } from 'react';
import { useTranslation } from "react-i18next";

const Captcha = ({ setCaptchaSuccess, alignItems = 'center', marginTopLabel = '2px', marginP = '12px' }) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsChecked(isChecked);
    setCaptchaSuccess(isChecked);
  };

  return (
    <div className="captcha-container" style={{ alignItems: alignItems, marginTop: marginTopLabel }}>
      <label className="catcha-checkbox">
        <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} style={{ marginRight: '10px' }} />
        {t("captcha.checkbox")}
      </label>
      <p className={`captcha-message ${isChecked ? 'checked' : 'not-checked'}`} style={{ margin: marginP }}>
        {isChecked ? t("captcha.checked") : t("captcha.not_checked")}
      </p>
      
    </div>
  );
};

export default Captcha;